import React from 'react'

export default function FormNewPost( props ) {
    const { inputHandler, uploadHandler } = props
    return (
        <div>
            <div className="col-12 col-md-8 col-lg-8 main-creation-container">
                    <div className="post-content-container border rounded bg-white">
                        <div className="post-content-header" >
                            <div>
                                <input 
                                    className="cover-image-input" 
                                    type="file" 
                                    id="cover-image" 
                                    onChange={uploadHandler}
                                />
                                <label 
                                    className="cover-image-label px-3 py-1" 
                                    htmlFor="cover-image"
                                >Add a cover image</label>
                            </div>
                            <div className="title-container p-1">
                                <textarea 
                                    className="w-100 publish-post" 
                                    type="text" name="title" 
                                    style={{fontWeight: "700", border: "none", resize: "none"}}  
                                    placeholder="New post title here..." 
                                    id="title-input"
                                    onChange={ inputHandler }
                                ></textarea>
                            </div>
                            <div className="tags-container p-1">
                                <label for="tag-input"></label>
                                <input 
                                    className="w-100 publish-post" 
                                    type="text" 
                                    name="tags" 
                                    style={{border: "none", fontFamily: "monospace"}}
                                    id="tag-input" 
                                    placeholder="Add up to 4 tags..."
                                    onChange={ inputHandler }
                                />
                            </div>
                        </div>
                        <div className="post-content-body p-1">
                            <div className="image-button-wrapper"></div>
                            <div className="text-container">
                                <label for="content-body"></label>
                                <textarea 
                                    className="w-100 publish-post" 
                                    type="text" 
                                    name="content" 
                                    placeholder="Write your post content here..." 
                                    style={{fontFamily: "monospace", minHeight: "890px", border: "none", resize: "none"}}
                                    id="content-body"
                                    onChange={ inputHandler }
                                ></textarea>
                            </div>
                        </div>
                    </div>
            </div> 
        </div>
    )
}
